import { render, staticRenderFns } from "./crm-five-documents.vue?vue&type=template&id=59d880c2&"
import script from "./crm-five-documents.vue?vue&type=script&lang=js&"
export * from "./crm-five-documents.vue?vue&type=script&lang=js&"
import style0 from "./crm-five-documents.vue?vue&type=style&index=0&id=59d880c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports